export default "__VITE_ASSET__C9qFOgn5__"